const highlightAnimationIds = [
  'highlight-first-animation',
  'highlight-second-animation',
  'highlight-third-animation',
  'highlight-fourth-animation'
];

export const isInViewport = (element) => {
  var bounding = element.getBoundingClientRect();

  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};

const triggerAnimations = (animationId) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const element = document.getElementById(animationId);

  if (element) {
    if (
      element.firstElementChild &&
      element.firstElementChild.tagName === 'VIDEO'
    ) {
      const playVideo = function () {
        element.firstElementChild.play();
      };

      if (!isMobile) {
        element.addEventListener('mouseover', playVideo);
      } else {
        window.addEventListener('scroll', function () {
          if (isInViewport(element)) {
            playVideo();
          }
        });
      }
    }
  }
};

const triggerHighlightAnimations = () =>
  highlightAnimationIds.map((animationId) => triggerAnimations(animationId));

export { triggerAnimations, triggerHighlightAnimations };
